
(() => {
  if (customElements.get('silo-features-carousel')) return;

  const ALLOW_PARALLAX = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class SiloFeaturesCarousel extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      this.swiper = null;

      // Below the fold on most pages → only build Swiper when it's near view.
      this._io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this._io.disconnect();
          this._io = null;
          this.boot();
        },
        { rootMargin: '300px' },
      );
      this._io.observe(this);
    }

    disconnectedCallback() {
      this._io?.disconnect();
      this._io = null;
      clearTimeout(this._swiperRetry);
      this.swiper?.destroy?.(true, true);
      this.swiper = null;
    }

    boot() {
      if (this._booted) return;
      this._booted = true;
      this.applyBackgrounds(); 
      this.initSwiper();
    }


    applyBackgrounds() {
      const desktop = window.matchMedia('(min-width: 768px)').matches;
      this.querySelectorAll('.feature-slide-inner').forEach((el) => {
        if (el.dataset.bgApplied) return;
        const url = (desktop ? el.dataset.bgDesktop : el.dataset.bgMobile) || el.dataset.bgDesktop;
        if (!url) return;
        el.style.backgroundImage = `url('${url}')`;
        el.dataset.bgApplied = '1';
      });
    }

    initSwiper() {
      const container = this.querySelector('.swiper-container');
      if (!container) return;

   
      if (typeof Swiper === 'undefined') {
        this._swiperTries = (this._swiperTries || 0) + 1;
        if (this._swiperTries > 100) return; // ~5s, then give up
        this._swiperRetry = setTimeout(() => this.initSwiper(), 50);
        return;
      }

      this.swiper = new Swiper(container, {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        loopAdditionalSlides: 1,
        speed: 800,
        spaceBetween: 80,
        grabCursor: true,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next-custom'),
          prevEl: this.querySelector('.swiper-button-prev-custom'),
        },
        breakpoints: {
          0: { slidesPerView: 1.2, spaceBetween: 16 },
          768: { slidesPerView: 1.79, spaceBetween: 120, centeredSlides: true },
        },
        on: ALLOW_PARALLAX
          ? { setTranslate: () => this.parallax() }
          : {},
      });

   
      this.applyBackgrounds();
      if (ALLOW_PARALLAX) this.parallax();
    }


    parallax() {
      const sw = this.swiper;
      if (!sw) return;
      const w = sw.width;
      for (const slide of sw.slides) {
        const inner = slide.querySelector('.feature-slide-inner');
        if (!inner) continue;
        const center = w / 2 - slide.swiperSlideOffset - slide.swiperSlideSize / 2;
        const posX = 50 - (center / w) * 25;
        inner.style.backgroundPosition = `${posX}% center`;
      }
    }
  }

  customElements.define('silo-features-carousel', SiloFeaturesCarousel);
})();
